export const LogSeverity = {
    ERROR: 'ERROR',
    INFO: 'INFO',
    WARNING: 'WARNING',
};
